import { IFilterFacet } from "../interfaces/interfaces";

const ontologySchema = "Eucaim/graphql";

export const initialFilterFacets: IFilterFacet[] = [
  {
    facetTitle: "Cancer condition",
    component: "OntologyFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Disease_types",
    applyToColumn: "collections.hasCondition.code",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [],
    ontologyIdentifiers: ["SNOMED-CT"],
    sortColumn: "name",
    sortDirection: "asc",
    negotiatorRequestString: "Condition(s):",
    showFacet: true,
    showMatchTypeSelector: true,
    adaptive: false,
  },
  {
    facetTitle: "Body part",
    component: "OntologyFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Body_parts",
    applyToColumn: "collections.hasImageBodyPart.code",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [],
    ontologyIdentifiers: ["SNOMED-CT"],
    sortColumn: "name",
    sortDirection: "asc",
    negotiatorRequestString: "Body part(s):",
    showFacet: true,
    showMatchTypeSelector: true,
    adaptive: false,
  },
  {
    facetTitle: "Geographical coverage",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Countries",
    applyToColumn: "spatial.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [],
    showMatchTypeSelector: false,
    negotiatorRequestString: "Countries:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Type",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Dataset_type",
    applyToColumn: "collections.type.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: ["other"],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Type(s):",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Collection method",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Collection_method",
    applyToColumn: "collections.collectionMethod.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [""],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Collection method(s):",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Birth Sex",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Sex",
    applyToColumn: "collections.hasBirthSex.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: ["other"],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Sex:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Image Modality",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Imaging_modality",
    applyToColumn: "collections.hasImageModality.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [""],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Imaging modality:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Image Equipment Manufacturer",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Manufacturer",
    applyToColumn: "collections.hasEquipmentManufacturer.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: ["other"],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Sex:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Access Rights",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Accessrights",
    applyToColumn: "collections.accessRights.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [""],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Access Rights:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Publisher",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Publisher",
    applyToColumn: "collections.publisher.id",
    filterValueAttribute: "id",
    filterLabelAttribute: "name",
    negotiatorRequestString: "Publisher(s):",
    sortColumn: "name",
    sortDirection: "asc",
    showFacet: true,
    adaptive: false,
  },
  {
    facetTitle: "Interoperability Tier",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Tier",
    applyToColumn: "collections.interoperabilityLevel.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [""],
    showMatchTypeSelector: true,
    negotiatorRequestString: "Interoperability tier:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "search",
    component: "StringFilter",
    negotiatorRequestString: "Text search is",
    builtIn: true /** search should not be generated */,
  },
];
